import React, { useEffect } from "react";

const StatisticsBar = () => {
  const data = [
    {
      id: 1,
      count: 500000,
      title: "MT Steel Supplied",
    },
    {
      id: 2,
      count: 800,
      title: "Projects",
    },
    {
      id: 3,
      count: 864,
      title: "Clients",
    },
    {
      id: 4,
      count: 1000,
      title: "Products",
    },
  ];
  const countTo = (id, count) => {
    let currentCount = 0;
    let speed = 15;
    if (count < 100) speed = 10;
    if (count < 25) speed = 50;
    if (count < 10) speed = 100;
    const increment = Math.ceil(count / 100);
    const element = document.getElementById(id);
    const interval = setInterval(() => {
      currentCount += increment;
      element.textContent = currentCount.toLocaleString("en-IN");
      if (currentCount >= count) {
        clearInterval(interval);
        element.textContent = count.toLocaleString("en-IN");
      }
    }, speed);
  };

  const countToAll = () => {
    data.forEach((item) => {
      countTo(`state${item.id}`, item.count);
    });
  };
  useEffect(() => {
    countToAll();
  }, []);
  return (
    <>
      <section className="pt-6 pb-4" id="count-stats">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 z-index-2 border-radius-xl mt-n9 mx-auto py-3 blur shadow-blur">
              <div className="row">
                {data.map((item) => (
                  <div
                    key={item.id}
                    data-aos="zoom-in-up"
                    className={`col-lg-3 col-md-3 col-6 text-center ${
                      item.id != 4 ? "position-relative" : ""
                    }`}
                  >
                    <div className="p-3 text-center">
                      <h2 className="textt-gradient">
                        {" "}
                        {/* <span id={`state${item.id}`} countto={15}>
                          5,00,000
                        </span> */}
                        <span id={`state${item.id}`}>0</span>
                        {/* <span>{item.count}</span> */}
                        {"+"}
                      </h2>
                      <h5 className="mt-3">{item.title}</h5>
                    </div>
                    {item.id != 4 ? <hr className="vertical dark" /> : ""}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default StatisticsBar;
